module.exports = __webpack_public_path__ + "img/overheads-travelling.02e876c9.svg";